import React from "react";
export const Localisation = ({ colorMain, colorDetail, size, info }) => (
	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width={size} className={info}>
		<g className="slide-right" >
			<path stroke={colorMain} fill="none" strokeWidth="1" d="M17 10.193c0 2.867-4.5 8.307-5 8.307s-5-5.44-5-8.307C7 7.325 9.239 5 12 5s5 2.325 5 5.193z" />
			<circle cx="12" cy="10" r="2" fill={colorDetail} />
		</g>
	</svg>
)